import {
  ClearButton,
  IconWrapper,
  StyledInput,
  Wrapper,
} from './SearchInput.styles.ts'
import SearchIcon from '@/core/assets/icons/search.svg'
import { InputProps } from '@mui/material'
import CrossIcon from '@/core/assets/icons/cross.svg'
import { ChangeEvent, FC, useEffect, useRef } from 'react'

interface Props extends Omit<InputProps, 'value' | 'placeholder' | 'onChange'> {
  value: string
  placeholder?: string
  onChange: (value: string) => void
  hideIcon?: boolean
}

const SearchInput: FC<Props> = ({
  value,
  onChange,
  placeholder,
  hideIcon = false,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const onClear = () => {
    onChange('')

    inputRef.current?.focus()
  }

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const searchIcon = (
    <IconWrapper>
      <SearchIcon />
    </IconWrapper>
  )

  const clearButton = value && (
    <ClearButton onClick={onClear}>
      <CrossIcon />
    </ClearButton>
  )

  return (
    <Wrapper>
      <StyledInput
        disableUnderline
        fullWidth
        placeholder={placeholder}
        startAdornment={hideIcon ? undefined : searchIcon}
        endAdornment={clearButton}
        inputRef={inputRef}
        value={value}
        onChange={handleChange}
        {...rest}
      />
    </Wrapper>
  )
}

export default SearchInput
